import React, { Component } from "react";
import { downloadS3Text } from "../libs/awsLib";
import config from "../config";
import { Link } from "react-router-dom";
import { Tab} from 'semantic-ui-react';
import SmartDetailReport from "./SmartDetailReport";

export default class Reports extends Component {
constructor (props) {
    super(props)
    this.state = 
    {
      tabIndex:0,
      securitygroups: false, 
      deviceConfigurations: {}, 
      alertConfigurations: {}
    }

}

async componentDidMount()
{
  this.loadDeviceConfigurations();
  this.loadAlertConfigurations();

  const parseurl=this.props.location.pathname.split('/')
  if (parseurl.length>=3)
  {
    if (parseurl[2])
    {
      this.setState({tabIndex: parseInt(parseurl[2])})
    }
    
  }

}

  loadDeviceConfigurations()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/deviceconfigurationrules.json';
    var deviceConfigurations={};
    downloadS3Text(bucket, key).then(result=>{Object.keys(result).forEach(key=>{deviceConfigurations[key]=key})}).then(()=>{this.setState({deviceConfigurations: deviceConfigurations})});
  }

  loadAlertConfigurations()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/alertconfigurations.json';
    var alertConfigurations={};
    downloadS3Text(bucket, key).then(result=>{Object.keys(result).forEach(key=>{alertConfigurations[key]=key})}).then(()=>{this.setState({alertConfigurations: alertConfigurations})});
  }

  render() {

    const smartDeviceReportDefinition={
        title: "Device Estate Report",
        reportName: "deviceestate", 
        icon: "disk icon", 
        pageSize: 20, 
        fields: [
          {fieldName: "id", title: "Id", type: "deviceid"}, 
          {fieldName: "deviceid", title: "Device Id", type: "text"}, 
          {fieldName: "importmpxn", title: "MPXN", type: "text"}, 
          {fieldName: "devicetype", title: "Device Type", type: "text"}, 
          {fieldName: "devicestatus", title: "Device Status", type: "text"}, 
          {fieldName: "deviceconfigurationrules", title: "Device Configuration", type: "text"}, 
          {fieldName: "manufacturer", title: "Manufacturer", type: "text", values: {'1015': 'Flonidan', '1031': 'Secure Meters (UK) Limited', '1057': 'Elster GmbH', '1063': 'Landis + Gyr', '106C': 'EDMI Europe Limited', '1072': 'Wistron NeWeb Corp', '1086': 'Toshiba', '1090': 'Green Energy Options Ltd', '10C7': 'Trilliant', '1125': 'Kaifa', '118F': 'Aclara', '1192': 'George Wilson Industries Ltd', '123E': 'Flonidan', '5401': 'Wistron NeWeb Corp'}}, 
          {fieldName: "model", title: "Model", type: "text"}, 
          {fieldName: "firmwareversion", title: "Firmware Version", type: "text"}, 
          {fieldName: "firmwareversionstatus", title: "Firmware Version", type: "text"}, 
          {fieldName: "cplstatus", title: "CPL Status", type: "text"}, 
          {fieldName: "cplexpirydate", title: "CPL Expiry", type: "date"}, 
          {fieldName: "smetsversion", title: "SMETS Version", type: "text"}, 
          {fieldName: "adoptionstatus", title: "Adoption Status", type: "text"}, 
          {fieldName: "adoptattemptcount", title: "Adoption Attempts", type: "text"}, 
          {fieldName: "effectivefrom", title: "Start Date", type: "date"}, 
          {fieldName: "datecommissioned", title: "Commissioning Date", type: "date"}, 
          {fieldName: "adoptiondate", title: "Adoption Date", type: "date"}, 
          {fieldName: "connectivity", title: "Connectivity", type: "connectivity"}, 
          {fieldName: "healthcheckstatus", title: "Healthcheck", type: "healthcheck"}
        ], 
        parameters: {
          devicetype: {label: "Device Type", values: {ESME: "ESME", GSME: "GSME"}, required: true}, 
          devicestatus: {label: "Device Status", values: {Commissioned: "Commissioned", Decommissioned: "Decommissioned", InstalledNotCommissioned: "InstalledNotCommissioned", Pending: "Pending", Suspended: "Suspended", Whitelisted: "Whitelisted"}}, 
          deviceconfigurationrules: {label: "Device Configuration", values: this.state.deviceConfigurations}, 
          alertconfigurationrules: {label: "Alert Configuration", values: this.state.alertConfigurations}, 
          manufacturer: {label: "Manufacturer", values: {'1015': 'Flonidan', '1031': 'Secure Meters (UK) Limited', '1057': 'Elster GmbH', '1063': 'Landis + Gyr', '106C': 'EDMI Europe Limited', '1072': 'Wistron NeWeb Corp', '1086': 'Toshiba', '1090': 'Green Energy Options Ltd', '10C7': 'Trilliant', '1125': 'Kaifa', '118F': 'Aclara', '1192': 'George Wilson Industries Ltd', '123E': 'Flonidan', '5401': 'Wistron NeWeb Corp'}}, 
          model: {label: "Model", type: "string"}, 
          firmwareversion: {label: "Firmware Version", type: "string"}, 
          firmwareversionstatus: {label: "Firmware Version Status", values: {Active: "Active", Cancelled: "Cancelled"}}, 
          smetsversion: {label: "SMETS Version", values: {"1": "SMETS 1", "2": "SMETS 2"}}, 
          adoptionstatus: {label: "Adoption Status", values: {Commissioned: "Commissioned", CommissioningFailed: "Commissioning Failed", Adopted: "Adopted", AdoptionFailed: "Adoption Failed"}}, 
          minstartdate: {label: "Start Date From", type: "date"}, 
          maxstartdate: {label: "Start Date To", type: "date"}, 
          mindatecommissioned: {label: "Commissioning Date From", type: "date"}, 
          maxdatecommissioned: {label: "Commissioning Date To", type: "date"}, 
          minadoptiondate: {label: "Adoption Date From", type: "date"}, 
          maxadoptiondate: {label: "Adoption Date To", type: "date"}, 
          mincplexpirydate: {label: "CPL Expiry Date From", type: "date"}, 
          maxcplexpirydate: {label: "CPL Expiry Date To", type: "date"}, 
          connectivity: {label: "Connectivity", values: {0: 'None', 1:'Poor', 2:'Average', 3:'Good'}}, 
          healthcheckstatus: {label: "Health Check Status", values: {1: 'OK', 2:'Warning', 3:'Error'}}
      }, 
      parameterDefaults: {devicetype: "ESME"}, 
      maxRows: 5000
    };

    const installAndCommissionReportDefinition={
      title: "Install and Commission Report",
      reportName: "installandcommission", 
      icon: "wrench", 
      columnHeaders: [], 
      pageSize: 20, 
      fields: [
        {fieldName: "id", title: "Id", type: "deviceid"}, 
        {fieldName: "datetime", title: "Install Date", type: "datetime"}, 
        {fieldName: "devicetype", title: "Device Type", type: "text"}, 
        {fieldName: "status", title: "Status", type: "text"}, 
        {fieldName: "source", title: "Source", type: "text"}, 
        {fieldName: "mpxn", title: "MPXN", type: "text"}, 
        {fieldName: "deviceeui", title: "Device EUI", type: "text"}, 
        {fieldName: "chfdeviceeui", title: "CHF Device EUI", type: "text"}, 
        {fieldName: "failedstep", title: "Failed Step #", type: "text"}, 
        {fieldName: "failedstepdescription", title: "Failed Step Description", type: "text"}, 
        {fieldName: "failedsteperrorcode", title: "Error Code", type: "text"}, 
      ], 
      parameters: {
        startdate: {label: "Start Date", type: "date"}, 
        enddate: {label: "End Date", type: "date"}, 
        devicetype: {label: "Device Type", values: {ESME: "ESME", GSME: "GSME"}, required: true}, 
        status: {label: "Status", values: {1: "In Progress", 2: "Failed", 3: "Complete"}}, 
        latestonly: {label: "Latest Only", type: "boolean"}, 
    }, 
    parameterDefaults: {}
  };

  const serviceRequestReportDefinition={
    title: "Service Request Report",
    reportName: "servicerequest", 
    icon: "tasks", 
    pageSize: 20, 
    parameters: {
      startdate: {label: "Start Date", type: "date", required: true}, 
      enddate: {label: "End Date", type: "date", required: true}, 
  }, 
  parameterDefaults: {startdate: null, enddate: null}
};

const healthCheckReportDefinition={
  title: "Healthcheck Report",
  reportName: "healthcheck", 
  icon: "first aid", 
  pageSize: 20, 
  fields: [
    {fieldName: "id", title: "Id", type: "deviceid"}, 
    {fieldName: "deviceid", title: "Device Id", type: "text"}, 
    {fieldName: "importmpxn", title: "MPXN", type: "text"}, 
    {fieldName: "devicetype", title: "Device  Type", type: "text"}, 
    {fieldName: "smetsversion", title: "SMETS Version", type: "text"}, 
    {fieldName: "healthcheckstatus", title: "Health Check Status", type: "healthcheck"}, 
    {fieldName: "datetime", title: "Date", type: "date"}, 
    {fieldName: "data", title: "Health Check Data", type: "healthcheckdata"}, 
   
  ], 
  parameters: {
    devicetype: {label: "Device Type", values: {ESME: "ESME", GSME: "GSME"}, required: true}, 
    smetsversion: {label: "SMETS Version", values: {"1": "SMETS 1", "2": "SMETS 2"}}, 
    deviceconfiguration: {label: "Device Configuration", values: this.state.deviceConfigurations}, 
    healthcheckstatus: {label: "Health Check Status", values: {1: 'OK', 2:'Warning', 3:'Error'}}
}, 
parameterDefaults: {devicetype: "ESME"}
};


    const panes = [
        { menuItem: {key: 'Smart Device Estate', content: 'Smart Device Estate', icon: 'disk icon'}, render: () => <Tab.Pane><SmartDetailReport darkmode={this.props.darkmode} reportdefinition={smartDeviceReportDefinition} /></Tab.Pane> }, 
        { menuItem: {key: 'Install and Commissions', content: 'Install and Commissions', icon: 'wrench'}, render: () => <Tab.Pane><SmartDetailReport darkmode={this.props.darkmode} reportdefinition={installAndCommissionReportDefinition} /></Tab.Pane> }, 
        { menuItem: {key: 'Service Requests', content: 'Service Requests', icon: 'tasks'}, render: () => <Tab.Pane><SmartDetailReport darkmode={this.props.darkmode} reportdefinition={serviceRequestReportDefinition} /></Tab.Pane> }, 
        { menuItem: {key: 'Health Check Report', content: 'Health Check Report', icon: 'first aid'}, render: () => <Tab.Pane><SmartDetailReport darkmode={this.props.darkmode} reportdefinition={healthCheckReportDefinition} /></Tab.Pane> }
      ]
    return (
      <div className="fullpage"> 
    <Tab grid= {{paneWidth: 13, tabWidth: 3}} menu={{tabular: false, fluid: true, vertical: true, className: this.props.darkmode ? "seaglassblueinverted-darkmode viewtabmenu" : "seaglassblueinverted viewtabmenu", inverted: true }} activeIndex={this.state.tabIndex} panes={panes} onTabChange={(event,data)=>{this.setState({tabIndex: data.activeIndex}); this.props.history.push('/reports/'+data.activeIndex)}} />
    </div>
    );  
  }
}
